import { render, staticRenderFns } from "./ModalProcessBackground.vue?vue&type=template&id=133206d7"
import script from "./ModalProcessBackground.vue?vue&type=script&lang=js"
export * from "./ModalProcessBackground.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports